export const KnownTags = {
  Public: 'public',
} as const

const findTagsInText = (text: string) => {
  const regex = /(?<![^\s,:])#[a-zA-Z][a-zA-Z0-9_-]*(=[^\s]*)?/g
  return Array.from(text.matchAll(regex), (m) => m[0]).map((h) =>
    h.slice(1).toLowerCase(),
  )
}

export default findTagsInText
